export enum UserRoles {
    FINAL_USER = "FINAL_USER",
    COMPANY_MANAGER = "COMPANY_MANAGER",
    COMPANY_ADMIN = "COMPANY_ADMIN",
    SUPER_ADMIN = "SUPER_ADMIN",
    CLIENT = 'CLIENT'
}